import { render, staticRenderFns } from "./grades.vue?vue&type=template&id=59bd851a&scoped=true"
import script from "./grades.vue?vue&type=script&lang=js"
export * from "./grades.vue?vue&type=script&lang=js"
import style0 from "./grades.vue?vue&type=style&index=0&id=59bd851a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bd851a",
  null
  
)

export default component.exports